export default __webpack_public_path__ + "static/media/email.37f93f36.svg";